import MainContainer from "./MainContainer"
import Nutrition from "./Nutrition"
import Referral from "./Referal"

export default function Main({user}){
    let contractAdr = "0xE62052F13b96863FFae25a4CCdC0cfee4eBA1FfC";
    return (
        <div className="main-container">
        <div className="all-contents">
            <MainContainer user={user} contractAdr={contractAdr}/>
            <Nutrition />
            <Referral user={user} />
        </div>
    </div>
    )
}